import React from 'react';
import {
  Wrapper,
  LoaderWrapper
} from './styled';
import { Icon } from '@app/src/common/Icon';


export const PlaceholderShimmer: React.FC = () => (
  <Wrapper>
    <LoaderWrapper>
        <Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} />
    </LoaderWrapper>
  </Wrapper>
)
